import { createFileRoute, Outlet } from "@tanstack/react-router";

// Shared components
import Footer from "@/components/shared/footer";
import Navbar from "@/components/shared/navbar";

function PublicLayout() {
  return (
    <div className="flex flex-col gap-5">
      <Navbar />

      <main
        className="flex flex-col gap-y-20 *:min-h-[50vh] px-10"
        role="main"
        aria-label="Main content area"
      >
        <Outlet />
      </main>

      <Footer />
    </div>
  );
}

export const Route = createFileRoute("/(public)/_public")({
  component: PublicLayout,

  errorComponent: ({ error }: { error: Error }) => (
    <div role="alert" className="p-4">
      <h1>Error</h1>
      <pre>{error.message}</pre>
    </div>
  ),
});
